import { Box } from '@material-ui/core'
import React from 'react'
import { Heading } from './Heading'
import { InfoWithDescription } from './InfoWithDescription'
import { NotKnown } from './NotKnown'

export const Experiences = ({ experience }) => {
    return (
        <Box p={2} pt={0} pb={2}>
            <Box
                pb={4}
                sx={{
                    borderBottom: 'solid 1px #E5E7EB',
                }}
            >
                <Heading heading={'Experiences'} />
                {experience?.length === 0 && <NotKnown message={'No Experience'} />}
                <>
                    {experience?.length > 0 &&
                        experience.map((exp, idx) => (
                            <InfoWithDescription
                                key={idx}
                                title={exp.title}
                                duration={exp.dateRange} //(2 years 3 months) implement total duration calculator
                            />
                        ))}
                </>
            </Box>
        </Box>
    )
}
